import axios from "infra/http";
import { useQuery } from "react-query";
import { HistoricoManutencaoLogs } from "./../typings/index";

function useHistoricoManutencao(id: string | undefined) {
  return useQuery(
    `/v1/manutencao/${id}/historico`,
    async () => {
      const { data } = await axios.get<HistoricoManutencaoLogs[]>(
        `/v1/manutencao/${id}/historico`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useHistoricoManutencao;
